import React from 'react'
import useGlobalTheme from '../../hooks/useGlobalTheme'

function GeneralSettings() {
	const theme = useGlobalTheme()
	const isLight = theme === 'light'

	return (
		<>
			<h2 className={`text-2xl font-bold mb-4 ${isLight ? 'text-gray-900' : 'text-white'}`}>General Settings</h2>
		</>
	)
}

export default GeneralSettings
